export default {
  footerText: "#687882",
  composerTextColor: "#414141",
  composerBorderColor: "#9da9b0",
  composerBackgroundColor: "white",
  composerIconColor: "#687882",
  composerIconHoverColor: "#414141",
  endUserMessageTextColor: "white",
  messageAuthorColor: "#353f45",
  messageTimestampColor: "#353f45",
  agentMessageTextColor: "#414141",
  agentMessageBackgroundColor: "#f5f8fa",
  conversationRatingHeaderBackgroundColor: "blue",
  conversationRatingBodyBackgroundColor: "white",
  textColor: 'white',
  backgroundColor: '#0071EB',
  foregroundColor: '#ffffff',
  widgetBackgroundColor: '#0071EB',
  activeColor: 'blue',
  gdprTextColor: '#212021'
}
